import { Separator } from '@design-system/Separator';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface DataCardProps {
  title: string;
  subtitle: string;
  content: string;
  footnote: string;
  source: string;
  link?: string;
}

export const DataCard = ({
  title,
  subtitle,
  content,
  footnote,
  source,
  link,
}: DataCardProps) => {
  const hasContentBelow = Boolean(footnote || source);
  return (
    <div className="w-full h-96 px-5 py-8 rounded-md bg-gradient-to-tr from-[#DCE5F0] to-[#E1F3E4] flex flex-col justify-between">
      <div className="flex flex-col">
        <p className="typography-caption1 text-tertiary">
          {title}
        </p>
        <p className="typography-caption1 text-tertiary">
          {subtitle}
        </p>
        <p className="typography-h3 text-primary line-clamp-6 mt-4">
          <abbr title={content} className='no-underline'>
            {content}
          </abbr>
        </p>
      </div>
      {hasContentBelow && (
        <div className="flex flex-col gap-2 mt-4">
          <Separator 
            className="bg-[#00000033]" 
            orientation="horizontal"
          />
          
          {footnote && (
            <p className="typography-body text-tertiary">
              {footnote}
            </p>
          )}
          
          {source && (
            link ? (
              <Link 
                to={link}
                target="_blank"
                rel="noopener noreferrer"
                className="typography-caption1 flex items-center gap-2"
              >
                {source}
                <ChevronRight className="w-8 h-8" />
              </Link>
            ) : (
              <p className="typography-caption1">
                {source}
              </p>
            )
          )}
        </div>
      )}
    </div>
  );
};